<template>
  <div class="preloader">
    <div class="preloader__content">
      <p v-text-animation>Just a moment</p>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'
import Splitting from 'splitting'

export default {
  name: 'Preloader',
  data: () => ({
    words: undefined
  }),
  directives: {
    'text-animation': {
      bind (el, binding, vnode) {
        vnode.context.words = Splitting({
          target: el,
          by: 'chars'
        })
        el.querySelectorAll('.char').forEach(char => {
          const tl = anime.timeline({
            direction: 'alternate',
            loop: true,
            duration: anime.random(1000, 2800)
          })
          tl
            .add({
              targets: char,
              opacity: [Math.random(), 1],
              easing: 'cubicBezier(0.55, 0.32, 0.62, 0.87)'
            })
        })
        anime.set(el, {
          filter: 'blur(2px)'
        })
        const tl = anime.timeline({
          direction: 'alternate',
          loop: true,
          duration: 2000
        })
        tl
          .add({
            targets: el,
            filter: 'blur(0px)',
            easing: 'cubicBezier(0.55, 0.32, 0.62, 0.87)'
          })
      }
    }
  }
}

</script>

<style lang="scss">

@import './style.scss';

</style>
